import React from 'react';
import { Route, Routes } from 'react-router-dom';
import SidebarHeaderLayout from '../container/SidebarLayout/SidebarLayout';
import ListUserBookcase from '../modules/common/Bookcase/ListUserBookcase';
import LoginPage from '../modules/common/Login/Login';
import Register from '../modules/common/Register/Register';
import RegisterDetails from '../modules/common/RegisterDetails/RegisterDetails';
import UserProfile from '../modules/user/UserProfile/UserProfile';
import { useUserStore } from '../store/useUser';
import PrivateRoutes from './PrivateRoutes/PrivateRoutes';
import Homepage from '../modules/common/Homepage/Homepage';
import MeetCandidates from '../modules/club/Candidates/MeetCandidates';
import BookSearch from '../modules/common/BookSearch/BookSearch';
import UserClubs from '../modules/user/UserClubs/UserClubs';
import { useMediaQuery } from 'react-responsive';
import ClubProfile from '../modules/club/ClubProfile/ClubProfile';
import ClubMeet from '../modules/club/ClubMeet/ClubMeet';
import AddMeet from '../modules/club/AddMeet/AddMeet';
import ClubList from '../modules/club/ClubList/ClubList';
import AddClub from '../modules/common/AddClub/AddClub';
import Sidebar from '../components/Sidebar/Sidebar';
import CustomHeader from '../components/Header/Header';
import Logout from '../modules/common/Logout/Logout';
import MemberList from '../modules/club/MemberList/MemberList';
import CreateBook from '../modules/common/CreateBook/CreateBook';
import UserMeets from '../modules/user/ClubMeet/UserMeets';
import Votes from '../modules/user/ListVotes/ListVote';
import AddElection from '../modules/club/AddVote/AddElection';
import ClubElections from '../modules/club/ListVotes/ClubElections';
import ListClubBookcase from '../modules/common/Bookcase/ListClubBookcase';
import EditClub from '../modules/club/EditClub/EditClub';
import EditUser from '../modules/user/EditUser/EditUser';
import CandidateBook from '../modules/club/Candidates/BookCandidates';
import CustomFooter from '../components/Footer/Footer';
import EditMemberList from '../modules/club/ManagerMemberList/ManagerMemberList';
import ResetPassword from '../modules/common/ResetPassword/ResetPassword';
import LocalBookInfo from '../modules/common/Book/BookLocalInfo';
import GoogleBookInfo from '../modules/common/Book/GoogleBookInfo';
import ClubForum from '../modules/club/ClubForum/ClubForum';
import ForumTopic from '../modules/common/ClubForum/ForumTopic/ForumTopic';
import ForumsList from '../modules/user/ForumsList/ForumsList';
import NotificationsList from '../modules/common/UserNotification/NotificationList/NotificationsList';
import AttendanceSummaryList from '../modules/club/Attendance/AttendanceSummaryList/AttendanceSummaryList';
import AttendancesList from '../modules/club/Attendance/AttendancesList/AttendancesList';
import RegisterAttendancesList from '../modules/club/Attendance/RegisterAttendancesList/RegisterAttendancesList';

const Pages = () => {
  const jwt = useUserStore(state => state.jwt)
  const isMobile = useMediaQuery({ query: '(max-width: 600px)' })

  return (
    <div>
      <CustomHeader />
      {isMobile && <Sidebar />}
      <SidebarHeaderLayout>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:email/:id" element={<ResetPassword />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/notifications" element={<PrivateRoutes authed={!!jwt} />}>
            <Route path="/notifications" element={<NotificationsList />} />
          </Route>
          <Route path="/register">
            <Route path="" element={<Register />}/>
            <Route path="details" element={<RegisterDetails />} />
          </Route> 
          <Route
              path="*"
              element={
                  <main style={{ padding: "1rem" }}>
                  <p>Página não encontrada!</p>
                  </main>
              }
          />
          <Route path="/book">
            <Route path="" element={<BookSearch/>}/>
            <Route path="add" element={<CreateBook/>}/>
            <Route path="google/:id" element={<GoogleBookInfo />} />
            <Route path="local/:id" element={<LocalBookInfo />} />
          </Route> 
          <Route path="/club">
            <Route path="" element={<ClubList/>}/>
            <Route path=":id/:name" element={<ClubProfile/>}/>
            <Route path=":id/:name/meets" element={<ClubMeet/>}/>
            <Route path=":id/:name/members" element={<MemberList />} />
            <Route path=":id/:name/bookcase" element={<ListClubBookcase/>}/>
            <Route path=":id/:name/vote/" element={<ClubElections/>}/>
          </Route>
          <Route path="/club" element={<PrivateRoutes authed={!!jwt}/>}>
            <Route path="add" element={<AddClub/>}/>
            <Route path="edit" element={<EditClub/>}/>
            <Route path=":id/:name/members/edit" element={<EditMemberList/>} />
            <Route path=":id/:name/meet/add" element={<AddMeet/>}/>
            <Route path=":id/:name/vote/add" element={<AddElection/>}/>
            <Route path=":id/:name/attendances" element={<AttendanceSummaryList />}/>
            <Route path=":id/:name/attendances/meet/:meetId" element={<AttendancesList />}/>
            <Route path=":id/:name/attendances/meet/:meetId/register" element={<RegisterAttendancesList />}/>
            <Route path=":clubId/election/:electionId">
              <Route path="candidates">
                <Route path="book/" element={<CandidateBook/>} />
                <Route path="meet/" element={<MeetCandidates/>} />
              </Route>
            </Route>
            <Route path=":id/:name/forum/">
              <Route path="" element={<ClubForum/>} />
              <Route path=":forumId/topic/:forumTopicId" element={<ForumTopic/>} />
            </Route>
          </Route>
          {/* User  */}
          <Route path="/user" element={<PrivateRoutes authed={!!jwt}/>}>
            <Route path="votes" element={<Votes />} />
            <Route path="config" element={<EditUser />} />
            <Route path="meets" element={<UserMeets />} />
            <Route path=":userId">
              <Route path="" element={<UserProfile />} />
              <Route path="bookcase" element={<ListUserBookcase/>} />
              <Route path="clubs" element={<UserClubs />} />
            </Route>
            <Route path="forums" element={<ForumsList />} />
          </Route>
          <Route
            path="*"
            element={
              <main style={{ padding: "1rem" }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </SidebarHeaderLayout> 
      <CustomFooter />
    </div>
  )
}

export default Pages;